import _ from 'lodash';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const jwtKey = 'token';

export default {
  actions: {
    async [actions.DO_LOGIN]({ commit, dispatch }, creds) {
      commit(mutations.SET_LOGIN);
      const params = {
        email: creds.email,
        password: creds.password,
        zoom: 'accounts',
      };
      const { data } = await HTTP.post('/tokens', params);
      commit(mutations.SET_AUTH_PAYLOAD, data.token);
      commit(mutations.SET_LOGIN_SUCCESS);
      return data;
    },
    [actions.DO_LOGOUT]({ commit }) {
      return new Promise((resolve) => {
        localStorage.removeItem(jwtKey);
        commit(mutations.SET_LOGOUT);
        commit(mutations.UNSET_AUTHENTICATED_USER);
        resolve();
      });
    },
    [actions.DO_SET_TOKEN]({ commit }) {
      return new Promise((resolve) => {
        const token = localStorage.getItem(jwtKey);
        if (token !== undefined) {
          commit(mutations.SET_AUTH_PAYLOAD, token);
        }
        resolve();
      });
    },
  },
  getters: {
    [getters.GET_IS_AUTHENTICATED]: state => state.isLoggedIn,
    [getters.GET_PAYLOAD]: state => state.payload,
  },
  mutations: {
    [mutations.SET_LOGIN](state) {
      state.pending = true;
    },
    [mutations.SET_LOGIN_SUCCESS](state) {
      state.isLoggedIn = true;
      state.pending = false;
    },
    [mutations.SET_AUTH_PAYLOAD](state, token) {
      localStorage.setItem(jwtKey, token);
      const headers = _.cloneDeep(HTTP.defaults.headers);
      headers.common.Authorization = token;
      HTTP.defaults.headers = headers;
      // const base64Url = token.split('.')[1];
      // const base64 = base64Url.replace('-', '+').replace('_', '/');
      // state.token = token;
      // state.payload = JSON.parse(atob(base64));
    },
    [mutations.SET_LOGOUT](state) {
      state.isLoggedIn = false;
      const headers = _.cloneDeep(HTTP.defaults.headers);
      delete headers.common.Authorization;
      HTTP.defaults.headers = headers;
    },
  },
  state: {
    pending: false,
    isLoggedIn: !!localStorage.getItem(jwtKey),
    token: null,
    payload: {
      data: {},
      expiry: null,
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js